import {
  FETCH_VEHICLES_DOCUMENTS_TYPES_DATA,
  FETCH_VEHICLES_DOCUMENTS_TYPES_SUCCESS,
  FETCH_VEHICLES_DOCUMENTS_TYPES_FAILURE,
} from "./actionTypes";

export const fetchVehiclesDocumentsTypesData = () => ({
  type: FETCH_VEHICLES_DOCUMENTS_TYPES_DATA,
});

export const fetchVehiclesDocumentsTypesSuccess = (data) => ({
  type: FETCH_VEHICLES_DOCUMENTS_TYPES_SUCCESS,
  payload: data,
});

export const fetchVehiclesDocumentsTypesFailure = (error) => ({
  type: FETCH_VEHICLES_DOCUMENTS_TYPES_FAILURE,
  payload: error,
});
